// extracted by mini-css-extract-plugin
module.exports = {"root":"SubmitAppButton_root__1YCLu"};